import styled from '@emotion/styled';
import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined';
import { InputLabel, Grid, Stack, Box } from '@mui/material';
import React from 'react';
import {
  TagsInput,
  WsColors,
  ControlledTextInput,
  WsTypography,
  WsTypoColors,
  WsTypoVariants,
} from 'wisestep-base';
import { string, array } from 'yup';

export const validationSchema = {
  cc: array().of(string().email('Please enter valid email addresses')),
  bcc: array().of(string().email('Please enter valid email addresses')),
  from: string().required('This field is required').email('Please enter a valid email address'),
  subject: string().required('Please enter a subject line'),
  body: string().required('The body cannot be empty'),
  to: array().min(1, 'Please enter at least one email address'),
};

export interface EmailFormProps {
  template?: string | null;
  subjectTemplate?: string | null;
  templateName?: string | null;
  toEmailList?: string[];
  fromEmailList: string[];
  resizable?: boolean;
  fromEmailSignature?: string;
  disableSend?: boolean;
  updateFromEmailSignature?: (fEmail: string) => void;
  manageSenderAccounts: () => void;
  openTemplatesList?: () => void;
  removeSelectedTemplate?: () => void;
  uploadAttachment: (arg1: File) => Promise<void>;
  handleAttachmentError: () => void;
  submitAction: <T>(arg: T) => Promise<void>;
  handleClose: () => void;
  ccList?: string[];
  bccList?: string[];
  isDirtyCallback: (isDirty: boolean) => void;
  deleteAttachmentHandler?: (selectedFileName: string) => void;
}
const EmailInputField = styled(TagsInput)(() => ({
  '.MuiOutlinedInput-root': {
    fieldset: {
      border: 'none',
    },
    padding: 0,
    margin: 0,
  },
  ':inputProps': {
    padding: 0,
  },
}));
export const AttachmentIcon = styled(InsertLinkOutlinedIcon)(() => ({
  color: WsColors.TheBlues500,
  transform: 'rotateZ(-45deg)',
}));

export const FileInput = styled(InputLabel)(() => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  justifyContent: 'space-between',
}));

export const SubjectInput = () => (
  <Grid xs={10}>
    <ControlledTextInput
      name="subject"
      type="text"
      fullWidth
      variant="standard"
      inputProps={{
        style: {
          padding: 0,
        },
      }}
      InputProps={{
        disableUnderline: true,
      }}
    />
  </Grid>
);
export type ReceiverInputType = {
  name: 'to' | 'cc' | 'bcc';
};
type FormLabelType = {
  label: string;
};
export const ReceiverInput = ({ name }: ReceiverInputType) => (
  <Grid xs={7} item>
    <EmailInputField name={name} initialValue={[]} multiple={true} />
  </Grid>
);

export const FormLabel = ({ label }: FormLabelType) => (
  <Grid xs={2} item>
    <Stack direction="row" justifyContent={'space-between'} pr={2}>
      <WsTypography bold={true} color={WsTypoColors.TERTIARY} variant={WsTypoVariants.BODY1}>
        {label}
      </WsTypography>
      <WsTypography bold={true} color={WsTypoColors.TERTIARY} variant={WsTypoVariants.BODY1}>
        :
      </WsTypography>
    </Stack>
  </Grid>
);
export const BuildInvalidEmailData = (emails: string[], label: string) => (
  <>
    {emails.length > 0 && (
      <Box mt={2}>
        <WsTypography variant={WsTypoVariants.CAPTION}>{label}</WsTypography>
        {emails.map((email, index) =>
          index != 0 ? (
            <WsTypography display="inline" bold={true} key={index}>{`, ${email}`}</WsTypography>
          ) : (
            <WsTypography display="inline" bold={true} key={index}>
              {email}
            </WsTypography>
          )
        )}
      </Box>
    )}
  </>
);
